import { useTranslation } from "react-i18next";

import { DataError, TableLoading } from "@digital-services/ui";
import { Pagination, useSortQueryString } from "@ds-cps/ui";

import { NoResultsWithIcon } from "@components/from_fota/NoResultsWithIcon";

import { useAuditLogContext } from "@audit-log/context";
import { CreateFilterOptionsForAuditLog } from "@audit-log/services/CreateFilterOptions";
import { useGetAuditLog } from "@audit-log/services/use-get-audit-log";

import { AuditLogTable } from "./table/AuditLogTable";

export const SectionAuditLogTable = () => {
  const { activeSort, sortDirection, handleSort } = useSortQueryString({
    defaultSort: "timestamp",
    defaultDirection: "descending"
  });

  const { dateRangeFilter } = useAuditLogContext();

  const created = new CreateFilterOptionsForAuditLog({
    dateRangeFilter
  });

  const { auditLog, isLoading, totalCount, hasError } = useGetAuditLog(
    activeSort, // is used to define sortBy value for Backend request
    sortDirection,
    created.filterOptions
  );

  const { t: tAuditLog } = useTranslation(undefined, {
    keyPrefix: "audit-log"
  });

  if (hasError) {
    return (
      <DataError message={tAuditLog("load.error.message")} variant="primary" />
    );
  }

  const noData = !hasError && (!totalCount || totalCount === 0);

  const hidePagination = !isLoading && noData;

  return (
    <>
      <div data-testid="audit-log-overview-table">
        {isLoading ? (
          <>
            <TableLoading isDarker />
            <TableLoading isDarker />
          </>
        ) : noData ? (
          <NoResultsWithIcon message={tAuditLog("load.none.message")} />
        ) : (
          <AuditLogTable
            auditLog={auditLog ?? []}
            activeSort={activeSort}
            sortDirection={sortDirection}
            handleSort={handleSort}
          />
        )}
      </div>

      {hidePagination ? null : <Pagination totalCount={totalCount!} />}
    </>
  );
};
